$( document ).ready(function() {

	// Select all checkboxes
	$("#selectall").on('click', function() {
	    $('input:checkbox').not(this).prop('checked', this.checked);
	});

	// Homepage: sticky top
	// Get the top
	// var top = document.getElementById("top");
	// Add the sticky class to the top when you reach its scroll position. Remove "sticky" when you leave the scroll position
	// function myFunction() {
	//   if (window.pageYOffset > 0) {
	//     top.classList.add("sticky")
	//   } else {
	//     top.classList.remove("sticky");
	//   }
	// }

	// When the user scrolls the page, execute myFunction 
	// window.onscroll = function() {myFunction()};
    

	// Scroll to
	$("#headerCta").click(function() {
    	$([document.documentElement, document.body]).animate({
        	scrollTop: $("#sectionSolutions").offset().top-100
    	}, 2000);
	});

	// Homepage: show approach card
	$( ".card" ).click(function() {
		if ($( this ).hasClass("is-active")) {
			// Homepage: hide approach card
				$( this ).children(".description").addClass("hide"); 
				$( this ).removeClass("is-active");
		} else {
			// Reset other cards
			$( ".card .description" ).addClass("hide");
			$( ".card" ).removeClass("is-active");

			// Then open card clicked by the user
			$( this ).addClass( "is-active" );
			$( this ).children(".description").removeClass("hide");
		}
	});
	// Close cards if users click outside the open card
	$('html').click(function() {
		// Close cards
		$( ".card .description" ).addClass("hide");
		$( ".card" ).removeClass("is-active");
	});
	$('.card').click(function(event){
		event.stopPropagation();
	});



	var arrayLinks = $(".menu-link");
	var arraySublinks = $(".top-sub-menu__sublink");

	arrayLinks.each(function (i, item) {
		// $(item).mouseover(function () {
		// 	var pos = $(item).position();
		// 	$(arraySublinks[i]).css(
		// 		{
		// 			// margin: "0 0 0 " + (pos.left + 10) + "px",
		// 			display: "block"
		// 		}
		// 	);
		// });
		$(item).mouseout(function () {
			$(arraySublinks[i]).css(
				{
					display: "none"
				}
			);
		});
	});

	var x = $("#menu-4").position();
	$("#submenu-1").css(
		{
			// margin: "0 0 0 " + (x.left + 10) + "px",
			display: "block"
		}
	);

    /**
     * Removes DOM elements of active filters using
     * fadeOut() jQuery method
     */
	if ($('.filter-btn__remove').length > 0) {
		// Remove selected filter
		$(document).on("click", ".filter-btn__remove", function () {
			$(this).parent().fadeOut();
		});

		//Remove all filters
		$(document).on("click", ".selected-filters__clear", function () {
			$('.filter-btn__remove').each(function () {
				$(this).parent().fadeOut();
			})
		});
	}

	var state = false;
	function showContent(arr, btn) {
		state = !state;
		if (!state) {
			$(arr).each(function () {
				$(this).addClass("show-more");
				$(this).find(".add-fav").addClass("show-more");
			});
			btn.addClass("rotated");
		} else {
			$(arr).each(function () {
				$(this).removeClass("show-more");
				$(this).find(".add-fav").removeClass("show-more");
			});
			btn.removeClass("rotated");
		}
	}

	$(".more-btn").click(function () {

		var titleCell = $(this).parent().parent().find(".title-cell");
		var topicCell = $(this).parent().parent().find(".topic-cell");

		showContent([titleCell, topicCell], $(this));
	});

	// if ($('.info-tooltip-wrapper').length > 0 &&
	// 	$('.show-tooltip').length > 0) {
	// 	var tooltipBtn = $('.show-tooltip');
	// 	var tooltipWindow = $('.info-tooltip-wrapper');
	//
	// 	var tooltipPos = {
	// 		left: tooltipBtn.offset().left - $(".default__content").offset().left,
	// 		top: tooltipBtn.offset().top - $(".default__content").offset().top
	// 	};
	//
	// 	tooltipBtn.mouseenter(function () {
	// 		tooltipWindow.addClass("show-more");
	// 		tooltipWindow.css({
	// 			"top": tooltipPos.top + 15,
	// 			"left": tooltipPos.left + 15
	// 		});
	// 	});
	//
	// 	tooltipBtn.mouseleave(function () {
	// 		tooltipWindow.removeClass("show-more");
	// 	});
	// }

	if ($('.select__button').length > 0 && $('.select__box').length > 0) {
		var button = $('.select__button');
		var box = $('.select__box');
		var state = true;

		button.on('click', function (e) {
			e.stopPropagation();
			state = !state;
			if (state === true) {
				$(this).parent().removeClass("active");
				box.removeClass("visible");
			} else {
				$(this).parent().addClass("active");
				box.addClass("visible");
			}
		});

		$(window).click(function() {
			//Hide the menus if visible
			button.parent().removeClass("active");
			box.removeClass("visible");
			state = !state;
		});
	}

	function outSideClick() {
		if (state) {
			$(window).on('click', function (e) {
				if (e.target !== box && e.target !== button) {
					state = false;
					box.removeClass("visible");
					button.parent().removeClass("active");
				}
			});
		}
	}

	// Homepage: cookies
	// show
	if($('.cookies').length && (localStorage.getItem('COOKIE') === null)) {
        $('.cookies').show();
    }
	// hide
	$('#cookie').on('click', function (e) {
        e.preventDefault();
        localStorage.setItem('COOKIE', 'COOKIE');
        $('.cookies').fadeOut('slow');
	});

	var coll = document.getElementsByClassName("collapsible");
	var i;

	for (i = 0; i < coll.length; i++) {
		coll[i].addEventListener("click", function () {
			this.classList.toggle("activated");
			var content = this.nextElementSibling;
			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				content.style.maxHeight = content.scrollHeight + "px";
			}
		});
	}

	// Admin views JS

	// $('input[name="check-all"]').click(function () {
	// 	$('table input:checkbox').not(this).prop('checked', this.checked);
	// });

	// Pop-up
	// Open:
	// $( ".popup-handle" ).click(function() {
	// 	var popupid = "#" + $(this).data("popup-id");
	// 	$(popupid).removeClass("hide");
	// 	$(popupid + " .popup-body").removeClass("hide");
	// });
	// // Close:
	// $( ".popup-close" ).click(function() {
	// 	popupCurrent = $(this).closest(".popup-container");
	// 	$(popupCurrent).addClass("hide");
	// 	$(popupCurrent + " .popup-body").addClass("hide");
	// });
	// $( ".popup-bg" ).click(function() {
	// 	popupCurrent = $(this).closest(".popup-container");
	// 	$(popupCurrent).addClass("hide");
	// 	$(popupCurrent + " .popup-body").addClass("hide");
	// });
	
	// $( ".admin-table .popup-open" ).click(function() {
	// 	$( "#admin-popup" ).removeClass("hide"); 
	// 	$( "#admin-popup .popup-body" ).removeClass("hide");
	// });	

	// Popup on clicking: "Utwórz grupę użytkowników"
	// $( ".popup-admin-add-open" ).click(function() {
	// 	$( "#admin-add-popup" ).removeClass("hide"); 
	// 	$( "#admin-add-popup .popup-body" ).removeClass("hide");
	// });	
	// $( "#admin-add-popup .popup-close" ).click(function() {
	// 	$( "#admin-add-popup" ).addClass("hide"); 
	// 	$( "#admin-add-popup .popup-body" ).addClass("hide-reveal"); 
	// });	

	// Popup on clicking: "Edytuj grupę"
	// $( ".popup-admin-edit-open" ).click(function() {
	// 	$( "#admin-edit-popup" ).removeClass("hide"); 
	// 	$( "#admin-edit-popup .popup-body" ).removeClass("hide");
	// });	
	// $( "#admin-edit-popup .popup-close" ).click(function() {
	// 	$( "#admin-edit-popup" ).addClass("hide"); 
	// 	$( "#admin-edit-popup .popup-body" ).addClass("hide-reveal"); 
	// });	

	// Popup on clicking the number of the users
	// $( ".popup-admin-users-open" ).click(function() {
	// 	$( "#admin-users-popup" ).removeClass("hide"); 
	// 	$( "#admin-users-popup .popup-body" ).removeClass("hide");
	// });	
	// $( "#admin-users-popup .popup-close" ).click(function() {
	// 	$( "#admin-users-popup" ).addClass("hide"); 
	// 	$( "#admin-users-popup .popup-body" ).addClass("hide-reveal"); 
	// });	
	
	// $( ".admin-popup .popup-bg" ).click(function() {
	// 	$( ".admin-popup" ).addClass("hide"); 
	// 	$( ".admin-popup .popup-body" ).addClass("hide-reveal"); 
	// });	

	$('.admin-popup').on('click', '.admin-popup__remove-item', function(){
		$(this).closest('li').fadeOut();
	});

	// Uploader

	// UPLOAD CLASS DEFINITION
    // ======================

    // var dropZone = document.getElementById('drop-zone');
    // var uploadForm = document.getElementById('js-upload-form');

    // var startUpload = function(files) {
    //     console.log(files)
	// }
	
	// if (uploadForm) {
	// 	uploadForm.addEventListener('submit', function(e) {
	// 		var uploadFiles = document.getElementById('js-upload-files').files;
	// 		e.preventDefault()
	
	// 		startUpload(uploadFiles)
	// 	})
	// }

    // dropZone.ondrop = function(e) {
    //     e.preventDefault();
    //     this.className = 'upload-drop-zone';

    //     startUpload(e.dataTransfer.files)
    // }

    // dropZone.ondragover = function() {
    //     this.className = 'upload-drop-zone drop';
    //     return false;
    // }

    // dropZone.ondragleave = function() {
    //     this.className = 'upload-drop-zone';
    //     return false;
    // }

	// $('.upload__open-dialog').on('click', function(){
	// 	$('#js-upload-files').trigger('click');
	// });

	// $('.upload__actions .collapse-btn').on('click', function(){
	// 	$(this).toggleClass('js-active');
	// 	$(this).closest('.upload__single').find('.upload__settings').toggleClass('js-active');
	// 	$(this).closest('.upload__single').find('.upload__header').toggleClass('js-active');
	// });
	// $('.upload__single .open-upload').on('click', function(){
	// 	$(this).closest('.upload__input-file').find('input[type="file"]').trigger('click');
	// });
	// $('.upload__single .check-all').on('click', function(){
	// 	$(this).closest('.checkbox-container').find('input:checkbox').not(this).prop('checked', this.checked);
	// });

	// SELECT2
	$('.select--custom').each(function() {
		var placeholder = $(this).data('placeholder');
		$(this).select2({
			minimumResultsForSearch: -1,
			placeholder: placeholder,
			width: '100%'
		});
	});

	// Checkbox related toggle
	$(".checkHandle").on("click", function() {
		var checkTarget = "#" + $(this).attr("data-related");
		$(this).toggleClass("checked");
		// $("# + 'checkTarget'").prop('checked', this.checked);
		// if ($(this).prop('checked', this.checked)) { $("# + 'checkTarget'").hide(); } else { $("# + 'checkTarget'").show(); } ;
		if ($(this).hasClass("checked")) { $(checkTarget).hide(); } else { $(checkTarget).show(); } ;
	});
	
});


$(document).ready(function () {
	// Search hints listing
    // $( "#searchInput" ).autocomplete({
    //   source: availableSearchItems
    // });

	// Hide notifications
    // $(".notification .close").on("click", function() {
	// 	$(this).closest(".notification").removeClass("is-visible");
	// });

	// If any checkbox is checked
	// $(".checkbox-controller").on("click", function() {
	// 	var whichOptionsGroup = $(this).data("options-group");
    //
	// 	if ($('.checkbox-controller:checked').length == 0) {
	// 		$('.checkbox-controlled-options.checkboxes-off[data-options-group="' + whichOptionsGroup + '"').removeClass("hide");
	// 		$('.checkbox-controlled-options.checkboxes-on[data-options-group="' + whichOptionsGroup + '"').addClass("hide");
	// 	} else {
	// 		$('.checkbox-controlled-options.checkboxes-off[data-options-group="' + whichOptionsGroup + '"').addClass("hide");
	// 		$('.checkbox-controlled-options.checkboxes-on[data-options-group="' + whichOptionsGroup + '"').removeClass("hide");
	// 	}
	// });

	// Visibility toggle
	// $(".visibility-toggle").on("click", function() {
	// 	var targetId = "#" + $(this).data("toggle-target");
	// 	$(targetId).toggleClass("hide");
	// });
		// Initiating datepickers
		// $( "input.datepicker" ).datepicker({ dateFormat: 'dd.mm.yy' });

});